var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xs-12 col-md-10" }, [
    _c(
      "div",
      { staticClass: "card-content col-sm-10 col-sm-offset-2 blogPost" },
      [
        _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } }),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.date))]),
          _vm._v(" "),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.content) } })
        ]),
        _vm._v(" "),
        _c(
          "footer",
          { staticClass: "card-footer" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: { path: "comments", query: { postID: _vm.postId } }
                }
              },
              [_vm._v("Read Comments")]
            ),
            _vm._v(" "),
            _c("router-view")
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e6afdb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6afdb0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/js/components/PostItem.vue
// module id = 399
// module chunks = 0